import { render, staticRenderFns } from "./RClickMenu.vue?vue&type=template&id=1439836c&"
import script from "./RClickMenu.vue?vue&type=script&lang=js&"
export * from "./RClickMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports